module.exports = __webpack_public_path__ + "static/icon-14f05279936a1e72953197cd056cc54a.png";